// curl --location 'account.duet.dev.p1.cn/v1/users/me/web-access-token?user_id=1223' \
// --header 'User-Agent: Duet/1.8.0 iOS14.4.2 iPhone' \
// --header 'Content-Type: application/json'

const url = 'http://account.duet.dev.p1.cn/v1/users/me/web-access-token?user_id=1375';

export async function getMyToken(context) {
  try {
    // const res = await fetch(url, {
    //   method: 'GET',
    //   headers: {
    //     'User-Agent': 'Duet/1.8.0 iOS14.4.2 iPhone',
    //     'Content-Type': 'application/json; charset=utf-8',
    //   },
    // });
    // const rt = await res.json();
    // return rt.token;

    // 首先检查 URL 中是否有 t 参数
    const { url } = context.req;
    if (url) {
      const protocol = context.req.protocol || 'http';
      const { host } = context.req.headers;
      const baseUrl = `${protocol}://${host}`;
      const urlParams = new URL(url, baseUrl).searchParams;
      const tParam = urlParams.get('t');
      console.log('url1111', url, tParam);
      if (tParam) {
        return tParam;
      }
    }

    const accessToken = context.req.headers['web-access-token'] || '';
    if (accessToken) {
      return accessToken;
    }
    return '';
  } catch (e) {
    return '';
  }
}

getMyToken();
